(() => {
  'use strict';
  if (window.vvAfCollectionInitialized) return;
  window.vvAfCollectionInitialized = true;
  let controller;

  function initialize() {
    const collection = document.querySelector('[data-vvaf-collection]');
    if (!collection) return;
    const source = collection.querySelector('[data-vvaf-filter-source]');
    if (!source) return;
    const groups = {
      category: '.vv-editorial-filter--category, .vv-editorial-filter--style',
      size: '.vv-editorial-filter--native[aria-label="Size"]',
      color: '.vv-editorial-filter--native[aria-label="Color"]'
    };
    for (const [name, selector] of Object.entries(groups)) {
      const slot = collection.querySelector(`[data-vvaf-filter-slot="${name}"]`);
      const panel = slot?.querySelector('.vvaf-collection__panel');
      const group = source.querySelector(selector);
      if (panel && !panel.childElementCount && group) panel.append(group);
      if (slot) slot.hidden = !panel?.querySelector('a[href], input:not([type="hidden"]), select, button');
    }
    source.hidden = !source.querySelector('.vvaf-collection__panel a[href], .vvaf-collection__panel input:not([type="hidden"]), .vvaf-collection__panel select, .vvaf-collection__panel button');
  }

  function positionPanel(details) {
    const panel = details.querySelector('.vvaf-collection__panel');
    const summary = details.querySelector('summary');
    if (!panel || !summary || !details.open) return;
    const anchor = summary.getBoundingClientRect();
    const width = Math.min(340, window.innerWidth - 24);
    const top = Math.max(12, Math.min(anchor.bottom + 6, window.innerHeight - 120));
    panel.style.width = `${width}px`;
    panel.style.left = `${Math.max(12, Math.min(anchor.left, window.innerWidth - width - 12))}px`;
    panel.style.top = `${top}px`;
    panel.style.maxHeight = `${Math.max(100, window.innerHeight - top - 12)}px`;
  }

  function closePanels(except) {
    document.querySelectorAll('[data-vvaf-popover][open]').forEach(details => {
      if (details !== except) details.open = false;
    });
  }

  function normalize(destination) {
    const url = new URL(destination, window.location.origin);
    url.searchParams.delete('view');
    return url;
  }

  async function navigate(destination, push, focusPopover, scrollToProducts = false) {
    const url = normalize(destination);
    const current = document.getElementById('CollectionAjaxContent');
    if (!current) return window.location.assign(url.href);
    if (controller) controller.abort();
    const request = new AbortController();
    controller = request;
    const oldCollection = current.querySelector('[data-vvaf-collection]');
    oldCollection?.setAttribute('aria-busy', 'true');
    const requestUrl = new URL(url);
    try {
      const response = await fetch(requestUrl.href, { signal: request.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Collection response unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incoming = html.getElementById('CollectionAjaxContent');
      if (!incoming?.querySelector('[data-vvaf-collection]')) throw new Error('Collection content unavailable');
      if (controller !== request) return;
      for (const section of current.querySelectorAll('[data-section-id][data-section-type]')) {
        section.dispatchEvent(new CustomEvent('shopify:section:unload', { bubbles: true, detail: { sectionId: section.dataset.sectionId } }));
      }
      current.replaceWith(incoming);
      if (push) history.pushState({ vvAfCollection: true }, '', url.href);
      if (html.title) document.title = html.title;
      for (const selector of ['link[rel="canonical"]', 'meta[name="description"]', 'meta[name="robots"]', 'meta[property="og:title"]', 'meta[property="og:description"]', 'meta[property="og:url"]', 'meta[name="twitter:title"]', 'meta[name="twitter:description"]']) {
        const next = html.head.querySelector(selector);
        const previous = document.head.querySelector(selector);
        if (next) {
          if (previous) previous.replaceWith(next);
          else document.head.append(next);
        } else if (previous && selector === 'meta[name="robots"]') previous.remove();
      }
      initialize();
      const collection = incoming.querySelector('[data-vvaf-collection]');
      const newWrapper = incoming.querySelector('.shopify-section');
      if (newWrapper && collection) newWrapper.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: collection.dataset.sectionId } }));
      window.theme?.reinitProductGridItem?.(window.jQuery ? window.jQuery(incoming) : undefined);
      const count = collection?.querySelector('[data-vvaf-result-count]');
      const status = collection?.querySelector('[data-vvaf-status]');
      if (status && count) status.textContent = count.textContent.trim();
      const originatingPopover = focusPopover && incoming.querySelector(focusPopover);
      (originatingPopover?.querySelector('summary') || count)?.focus({ preventScroll: true });
      if (scrollToProducts) collection?.querySelector('.vvaf-collection__toolbar')?.scrollIntoView({ block: 'start', behavior: 'auto' });
      document.dispatchEvent(new CustomEvent('vv:collection:updated', { detail: { url: url.href } }));
    } catch (error) {
      if (error.name === 'AbortError') return;
      window.location.assign(url.href);
    } finally {
      if (controller === request) {
        controller = undefined;
        document.querySelector('[data-vvaf-collection]')?.removeAttribute('aria-busy');
      }
    }
  }

  document.addEventListener('click', event => {
    closePanels(event.target.closest?.('[data-vvaf-popover]'));
    const link = event.target.closest?.('[data-vvaf-collection] a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || link.target) return;
    const destination = normalize(link.href);
    if (destination.origin !== window.location.origin || !destination.pathname.startsWith('/collections/') || destination.pathname.includes('/products/')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const popover = link.closest('[data-vvaf-popover]');
    const slot = popover?.dataset.vvafFilterSlot;
    const focusPopover = slot ? `[data-vvaf-filter-slot="${slot}"]` : ['department', 'filters', 'sorting'].map(name => `.vvaf-collection__${name}`).find(selector => popover?.matches(selector));
    navigate(destination.href, true, focusPopover, Boolean(link.closest('.vvaf-collection__pagination')));
  }, true);

  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!details.matches?.('[data-vvaf-popover]') || !details.open) return;
    closePanels(details);
    positionPanel(details);
  }, true);

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest?.('[data-vvaf-popover][open]') || document.querySelector('[data-vvaf-popover][open]');
    if (!details) return;
    event.preventDefault();
    details.open = false;
    details.querySelector('summary')?.focus();
  });

  for (const eventName of ['resize', 'scroll']) window.addEventListener(eventName, () => {
    document.querySelectorAll('[data-vvaf-popover][open]').forEach(positionPanel);
  }, { passive: true, capture: eventName === 'scroll' });

  window.addEventListener('popstate', event => {
    if (!document.querySelector('[data-vvaf-collection]') || !window.location.pathname.startsWith('/collections/')) return;
    event.stopImmediatePropagation();
    navigate(window.location.href, false);
  }, true);

  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
